export default __webpack_public_path__ + "static/media/mlbFantasyPWRSDark.63ef0aa9.png";